import React from "react";
import PropTypes from "prop-types";
import {
    WidgetContainer,
    Content,
    Name,
    Data,
    TopImage,
    Price,
    PlusMinus,
    Amount,
} from "./style";
import AddButton from "../Button/AddButton";
import {
    formatPrice,
    getTotalEnergy,
    calculateFranchisePrice,
} from "../../Helpers/util";

const SmallWidget = (props) => {
    if (!props.ingredient) return null;

    return (
        <WidgetContainer>
            <TopImage
                transparentImage={props.transparentImage}
                style={{
                    backgroundImage: `url(${props.ingredient.images.thumb})`,
                }}
            />

            <Content>
                <Name>{props.ingredient.name}</Name>
                <Data>
                    {props.ingredient.details.energy ? (
                        `${Math.round(getTotalEnergy(props.ingredient))} kcal`
                    ) : (
                        <div style={{ flex: 1 }} />
                    )}
                    <PlusMinus>
                        <AddButton
                            buttonState="subtract"
                            onClick={props.onRemove}
                        />
                        <Amount>{props.amount}</Amount>
                        {!props.binary && (
                            <AddButton
                                buttonState="add"
                                onClick={props.onAdd}
                            />
                        )}
                    </PlusMinus>
                </Data>
                {!props.binary && (
                    <Price>
                        {props.isFree
                            ? "Kostenlos"
                            : `+ ${formatPrice(
                                  calculateFranchisePrice(
                                      props.storeId,
                                      props.ingredient
                                  ) * props.amount
                              )}`}
                    </Price>
                )}
            </Content>
        </WidgetContainer>
    );
};

SmallWidget.defaultProps = {
    amount: 0,
    onAdd: () => {},
    onRemove: () => {},
};

SmallWidget.propTypes = {
    ingredient: PropTypes.any,
    binary: PropTypes.bool,
    amount: PropTypes.number,
    onAdd: PropTypes.func,
    onRemove: PropTypes.func,
    isFree: PropTypes.bool,
    transparentImage: PropTypes.bool,
};

export default SmallWidget;
